var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.046,
    height: 19.078,
    viewBox: "0 0 19.046 19.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M-4.254-2.707A25.894,25.894,0,0,0-1.128-.016,16.465,16.465,0,0,0,2.159,1.875a8.029,8.029,0,0,0,3.115.693,4.762,4.762,0,0,0,1.858-.36A4.427,4.427,0,0,0,8.69,1.085,4.288,4.288,0,0,0,9.33.107,2.412,2.412,0,0,0,9.571-.924a1.87,1.87,0,0,0-.161-.763,1.46,1.46,0,0,0-.548-.623L5.736-4.522a2.778,2.778,0,0,0-.661-.387,1.65,1.65,0,0,0-.6-.118,1.334,1.334,0,0,0-.671.188,3.121,3.121,0,0,0-.671.542L2.4-3.588a.49.49,0,0,1-.387.172.6.6,0,0,1-.226-.043L1.6-3.534a7.558,7.558,0,0,1-1.23-.892Q-.376-5.06-1.139-5.812T-2.524-7.321A7.247,7.247,0,0,1-3.405-8.54a1.658,1.658,0,0,1-.081-.193.678.678,0,0,1-.038-.226.493.493,0,0,1,.161-.376l.72-.741a3.515,3.515,0,0,0,.532-.682,1.352,1.352,0,0,0,.188-.682,1.581,1.581,0,0,0-.124-.58,3.6,3.6,0,0,0-.371-.677l-2.2-3.083a1.66,1.66,0,0,0-.645-.553,1.866,1.866,0,0,0-.806-.177,2.8,2.8,0,0,0-1.966.881,4.472,4.472,0,0,0-1.1,1.59,4.983,4.983,0,0,0-.344,1.848,8.044,8.044,0,0,0,.688,3.11A16.484,16.484,0,0,0-6.923-5.817,25.115,25.115,0,0,0-4.254-2.707Z",
    transform: "translate(9.475 16.511)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.af3351fd5cbf9d278ef2721c9f39a54f.svg";
export { ForwardRef as ReactComponent };